<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main" v-if="singlereferral">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-shuffle" style="font-size: 22px;"></i>
            </div>
            <div class="flex-grow-1">
              <h4 class="mb-0 font-weight-bold">Referral Details</h4>
              <div class="d-flex align-items-center mt-1" style="gap: 8px;">
                <span v-if="singlereferral.status == 'approved'" class="badge badge-soft-success px-3 py-1"
                  style="border-radius: 20px; font-size: .8rem;">approved</span>
                <span v-if="singlereferral.status == 'rejected'" class="badge badge-soft-danger px-3 py-1"
                  style="border-radius: 20px; font-size: .8rem;">rejected</span>
                <span v-if="singlereferral.status == 'pending'" class="badge badge-soft-warning px-3 py-1"
                  style="border-radius: 20px; font-size: .8rem;">pending</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Action Bar -->
        <div class="card action-card shadow mb-4">
          <div class="card-body py-3 px-4 d-flex flex-wrap align-items-center" style="gap: 8px;">
            <button class="btn btn-sm btn-outline-secondary" @click="printMe">
              <i class="fe fe-printer mr-1"></i> Print
            </button>

            <button class="btn btn-sm btn-outline-info" @click="shownotes = !shownotes">
              <i class="fe fe-clipboard mr-1"></i> {{ singlereferral.comments.length }} Notes
            </button>

            <button type="button" v-if="encounter != null" class="btn btn-sm btn-outline-info"
              data-toggle="modal" data-target="#slideRightModal">
              <i class="fe fe-eye mr-1"></i> View Encounter Details
            </button>

            <button class="btn btn-sm btn-outline-secondary" @click="copyCode">
              <i class="fe fe-copy mr-1"></i> Copy Authorization Code
            </button>

            <div class="ml-auto d-flex flex-wrap" style="gap: 6px;">
              <button class="btn btn-sm btn-success" @click="verifyRef" v-if="
                  (singlereferral.status != 'rejected' &&
                    singlereferral.status != 'approved' &&
                    user.type == 'tpa') ||
                  user.type == 'tpa_employee'
                ">
                <i class="fe fe-lock mr-1"></i> Generate Authorization Code
              </button>

              <button class="btn btn-sm btn-danger" @click="rejectRef" v-if="
                  (singlereferral.status != 'rejected' &&
                    singlereferral.status != 'approved' &&
                    user.type == 'tpa') ||
                  user.type == 'tpa_employee'
                ">
                <i class="fe fe-x mr-1"></i> Reject
              </button>
            </div>
          </div>

          <!-- Rejection comment form -->
          <div class="card-body pt-0" v-show="show">
            <label class="font-weight-bold text-secondary small">Please add a Rejection Comment</label>
            <textarea rows="4" class="form-control mb-3" v-model="body"></textarea>
            <button type="button" class="btn btn-submit px-4" @click="addComment">
              <i class="fe fe-send mr-1"></i> Submit
            </button>
          </div>
        </div>

        <div id="printDiv" ref="printNow">

          <!-- Notes -->
          <div class="row mb-4" v-show="shownotes">
            <div class="col-md-12">
              <div class="card shadow table-card">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-clipboard" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Notes</h6>
                </div>
                <div class="card-body">
                  <div class="note-item" v-for="comment in singlereferral.comments" v-bind:key="comment.id">
                    <p class="mb-1">{{ comment.body }}</p>
                    <small class="text-muted">
                      By: {{ comment.user.firstname }} {{ comment.user.lastname }} —
                      <span class="text-capitalize">{{ comment.user.type }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Patient Details -->
          <div class="row mb-4">
            <div class="col-md-6 mb-4 mb-md-0">
              <div class="card shadow table-card h-100">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-user" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Patient Information</h6>
                </div>
                <ul class="list-unstyled mb-0">
                  <li class="info-row">
                    <i class="fe fe-user info-icon"></i>
                    <div>
                      <p class="info-label">Full Name</p>
                      <p class="info-value">{{ singlereferral.client.firstname }} {{ singlereferral.client.lastname }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-phone info-icon"></i>
                    <div>
                      <p class="info-label">Phone Number</p>
                      <p class="info-value">{{ singlereferral.client.phone_number }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-hash info-icon"></i>
                    <div>
                      <p class="info-label">RIVCHPP Number</p>
                      <p class="info-value"><span class="code-chip">{{ singlereferral.client.id_card_number }}</span></p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Gender</p>
                      <p class="info-value">{{ singlereferral.client.gender }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-briefcase info-icon"></i>
                    <div>
                      <p class="info-label">HMO</p>
                      <p class="info-value">{{ singlereferral.tpa.organization_name }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Date of Birth</p>
                      <p class="info-value">{{ singlereferral.client.dob }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map-pin info-icon"></i>
                    <div>
                      <p class="info-label">Address</p>
                      <p class="info-value">{{ singlereferral.client.address }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card shadow table-card h-100">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-file-text" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Referral Information</h6>
                </div>
                <ul class="list-unstyled mb-0">
                  <li class="info-row" v-if="singlereferral.referred">
                    <i class="fe fe-map-pin info-icon"></i>
                    <div>
                      <p class="info-label">Recipient Facility</p>
                      <p class="info-value">{{ singlereferral.referred.agency_name }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="singlereferral.referring">
                    <i class="fe fe-home info-icon"></i>
                    <div>
                      <p class="info-label">Referring Facility</p>
                      <p class="info-value">{{ singlereferral.referring.agency_name }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="singlereferral.diagnosis != null">
                    <i class="fe fe-alert-circle info-icon"></i>
                    <div>
                      <p class="info-label">Provisional Diagnosis</p>
                      <p class="info-value">{{ singlereferral.diagnosis.name }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-user-check info-icon"></i>
                    <div>
                      <p class="info-label">Prepared by</p>
                      <p class="info-value">{{ singlereferral.creator.firstname }} {{ singlereferral.creator.lastname }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-clock info-icon"></i>
                    <div>
                      <p class="info-label">Date Prepared</p>
                      <p class="info-value">{{ singlereferral.created_at }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-key info-icon"></i>
                    <div>
                      <p class="info-label">Authorization Code</p>
                      <p class="info-value">
                        <button class="btn btn-sm btn-outline-secondary" @click="copyCode">
                          {{ singlereferral.authorization_code }} <i class="fe fe-copy ml-1"></i>
                        </button>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Reason for Referral -->
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card shadow table-card">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-file" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Referral Note / Reason for Referral</h6>
                </div>
                <div class="card-body">
                  {{ singlereferral.reason }}
                </div>
              </div>
            </div>
          </div>

          <!-- Treatment Given -->
          <div class="row">
            <div class="col-md-12">
              <div class="card shadow table-card">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-file" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Treatment Given</h6>
                </div>
                <div class="card-body">
                  {{ singlereferral.treatment_given }}
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Encounter Modal -->
        <div
          class="modal fade modal-slide-right"
          id="slideRightModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="slideRightModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header" style="background: linear-gradient(135deg, #1e3a5f, #2563eb);">
                <h5 class="modal-title text-white font-weight-bold" id="slideRightModalLabel">
                  Encounter Details
                </h5>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div v-if="encounter != null">
                  <p class="h5 font-weight-bold">{{ encounter.reasonVisit }}</p>
                  <p class="mb-2"><i class="fe fe-calendar mr-1"></i>{{ encounter.date_of_visit }}</p>
                  <p class="mb-3"><i class="fe fe-monitor mr-1"></i>{{ encounter.medications }}</p>

                  <div class="card table-card">
                    <div class="form-card-header">
                      <h6 class="mb-0 font-weight-bold text-white">Service/Drugs Administered During Encounter</h6>
                    </div>
                    <table class="table align-td-middle mb-0">
                      <thead style="background: #f8fafc;">
                        <tr>
                          <th class="table-th">S/No.</th>
                          <th class="table-th">Type</th>
                          <th class="table-th">Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(service, index) in encounter.service.servicesrenderred" v-bind:key="service.id">
                          <td class="px-4 py-2">{{ index + 1 }}</td>
                          <td class="py-2">Service</td>
                          <td class="py-2">{{ service.description }}</td>
                        </tr>
                        <tr v-for="(service, index) in encounter.service.drugs" v-bind:key="service.id">
                          <td class="px-4 py-2">{{ index + 1 }}</td>
                          <td class="py-2">Drug</td>
                          <td class="py-2">{{ service.drug_name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Encounter Modal -->

      </div>

      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      singlereferral: "",
      encounter: "",
      comments: "",
      shownotes: false,
      facility: "",
      clientdetail: "",
      body: "",
      show: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
    };
  },
  beforeMount() {
    //
  },
  methods: {
    getReferral() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/referrals/${this.$route.params.id}`)
        .then((response) => {
          this.singlereferral = response.data.referral;
          this.encounter = response.data.encounter;

          console.log(response);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = true;
        });
    },

    addComment() {
      this.axios
        .post(`/api/v1/auth/addComment/referral`, {
          user_id: this.user.id,
          referral_id: this.$route.params.id,
          body: this.body,
        })
        .then((response) => {
          console.log(response);
          this.getReferral();
          this.$router.push(`/all-referrals`);
          this.$toasted.info("added Successfully!", {
            position: "top-center",
            duration: 3000,
          });
        });
    },

    rejectRef() {
      if (confirm("Are you sure you want to reject this request?")) {
        this.axios
          .post(`/api/v1/auth/generate-token/${this.$route.params.id}`, {
            type: "rejection",
          })
          .then((response) => {
            console.log(response);
            this.show = true;
            this.getReferral();
            this.$toasted.info("Rejected Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },
    verifyRef() {
      if (
        confirm(
          "Are you sure you want to generate authorization code to approve?"
        )
      ) {
        this.axios
          .post(`/api/v1/auth/generate-token/${this.$route.params.id}`, {
            type: "approval",
          })
          .then((response) => {
            console.log(response);
            this.getReferral();
            this.$router.push(`/all-referrals`);
            this.$toasted.info("Approved Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },

     copyCode() {
      const copyToClipboard = (text) => navigator.clipboard.writeText(text);
      copyToClipboard(this.singlereferral.authorization_code);
      this.$toasted.info("Copied to clipboard", {
        position: "top-center",
        duration: 3000,
      });
    },
    printMe() {
      var printContents = document.getElementById("printDiv").innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
  },
  created() {
    this.getReferral();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}
.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mt-n3 { margin-top: -16px; }

.action-card, .table-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-number {
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.table-th {
  font-size: 0.73rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0;
  padding: 12px 16px;
}

.note-item {
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}
.note-item:last-child { border-bottom: none; }

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
</style>
